import { hasAtLeast, isArray } from 'remeda'
import type { MenuItem } from '@velasca/types'

export const getMacroCategoriesChildren = (
  menuItems: MenuItem[],
): MenuItem[] => {
  const result: MenuItem[] = []

  if (menuItems) {
    for (const item of menuItems) {
      if (
        item.url?.includes('collections') &&
        isArray(item.children) &&
        hasAtLeast(item.children, 1)
      ) {
        // we are doing this because of https://velasca.atlassian.net/browse/VAMS-249?focusedCommentId=18666
        const filteredChildren = item.children.filter(
          (child) => child.handle !== item.handle,
        )

        result.push(...filteredChildren)
      }
    }
  }

  return result
}
